'use strict';

import { Dropdown } from './dropdown.js';

export class DropdownBasicdropdown extends Dropdown {
	constructor(component_key) {
		super(component_key);
	}
	add_events() {
		const option_selector = `.js-${this.id}_option`;
		this.$selected.on('click', option_selector, (event) => {
			const handler = this.selected_click_handler;
			handler.call(this, event);
		});
		this.$list.on('click', option_selector,
			this.option_click_handler.bind(this)
		);
		jQuery(`.js-${this.id}`).on('blur', this.close_all.bind(this));
	}
	
	option_click_handler(event) {
		event.preventDefault();
		const $id = jQuery(event.currentTarget).data('id');
		const $redirect_url = jQuery('.js-email_alert_time').data('redirect-url');
		if ($id === 'i' && $redirect_url) {
			//Open the Overly instead
			yalwa.mobile.load_pa_plan_overlay('instant_notification');
			return;
		} else {
			jQuery('.js-email_alert_time').val($id);
		}
		const $element = jQuery(event.currentTarget);		
		$element.addClass('dropdown__item--selected').siblings().removeClass('dropdown__item--selected');
		this.$selected.empty().append($element.clone());
		this.close_all(event);
	}
	last_viewed() {
		
	}
}
